// 罗马尼亚语
import constant from '../../constants/lang/ro';
import newLang from '../newLang/ro';
/* eslint-disable max-len */
export default {
  cfmoto: {
    ...(newLang.cfmoto || {}),
    constant,
    api: {
      http: {
        401: 'Vă rugăm să vă conectați mai întâi',
        404: 'Nu există date',
        500: 'Sistemul este ocupat, vă rugăm să încercați din nou mai târziu',
        504: 'Cererea a expirat',
        ERR_NETWORK: 'Excepție de rețea',
        ERR_NETWORK_UPLOAD: 'Încărcarea nu a reușit, vă rugăm să încercați o altă rețea',
      },
    },
    title: '智能网联国际版管理后台',
    navbar: {
      dropdown: {
        updatePassword: '修改密码',
        switchLanguage: '切换语言',
        logout: '退出登录',
      },
    },
    router: {
      title: {
        'binding-agreement': '绑车协议',
        introduce: '介绍',
        lamp: 'Indicator lumină',
        download: 'CFMOTO RIDE APP Download',
        orderConfirm: 'Order Confirmation',
        ebook: 'ebook',
        list: 'ebook',
        pdf: 'PDF',
        feedback: 'Înregistrări',
        'feedback-create': 'Feedback',
        'feedback-supplement': 'Feedback suplimentar',
        'feedback-detail': 'Detalii de feedback',
        'feedback-result': 'Feedback',
        guide: 'Centru de ajutor',
        'guide-restScreen': 'Cum se configurează vehiculul de boot',
        'guide-overview': 'Prezentare generală a funcțiilor',
        'guide-account': 'Despre cont',
        'guide-vehicle': 'Despre vehicul',
        'guide-meterSetting': 'Cum se configurează tabloul de bord',
        'guide-vehicleSetting': 'Cum se configurează vehiculul',
        'guide-findNavigation': 'Cum să navigați pentru a găsi vehiculul',
        'guide-vehicleNnavigation': 'Cum să utilizați navigația',
        'guide-cyclingRecord': 'Despre istoricul cursei',
        'guide-vehicleExperience': 'Cum să efectuați o autoinspecție a vehiculului',
        'guide-useSetting': 'Cum să faci setările generale ale aplicației',
        'guide-notice': 'Cum să vizualizați și să setați notificarea mesajului',
        'guide-about': 'Despre APP',
        help: 'Ajutor și feedback',
        'help-detail': 'Detalii intrebare',
        'myCar-unbinding': 'Aplicarea dezlegării',
        'myCar-unbinding-result': 'Aplicarea dezlegării',
      },
    },
    form: {
      cancel: 'Anulează',
      confirm: 'Confirmați',
      submit: 'Trimite',
      search: 'Căutare',
      language: {
        languageCode: {
          label: '请选择语言：',
          placeholder: '请选择语言',
        },
      },
    },
    rules: {
      language: {
        languageCode: {
          required: '请选择语言',
        },
      },
    },
    dialog: {
      language: '语言选择',
    },
    binding: {
      title: `Protocol`,
      text1: '1.	Servicii telematice',
      text2:
        'CFMOTO Powersports, Inc. (denumită în continuare „ CFMOTO ” ) oferă servicii de telematică pentru vehicule clientului care a cumpărat vehiculul CFMOTO (denumit în continuare „Client” ). Pentru aceste servicii, CFMOTO folosește datele înregistrate de Vehicul despre Vehicul și comportamentul său de conducere în perioada de timp relevantă. În detaliu, aceasta se referă la următoarele date:',
      text3: 'Date despre comportamentul de condus al utilizatorului : inclusiv accelerația, decelerația, viteza, îndoirea, ultimul timp de condus și ultimul kilometraj de condus .',
      text4:
        'Date despre starea vehiculului: se referă la starea în timp real a vehiculului, inclusiv modul de conducere, combustibil rezidual, economia instantanee de combustibil, kilometrajul, viteza de viteză în timp real a vehiculului, turația motorului, presiunea anvelopelor, temperatura anvelopelor, datele privind tensiunea de activare a bateriei , temperatura lichidului de răcire, starea blocării electronice, versiunea software a dispozitivului inteligent, puterea semnalului dispozitivelor inteligente, setarea curentă a tabloului de bord.',
      text5:
        'Date de alarmă vehicul: date de alarmă care trebuie trimise dacă anumite date depășesc o valoare prestabilită, cum ar fi temperatura motorului, viteza excesivă, timpul excesiv de condus, temperatura ridicată a lichidului de răcire, mișcarea anormală a vehiculului, presiunea anormală a anvelopelor, vibrațiile, descărcarea, coliziunea etc. .',
      text6: 'Informații de eroare vehicul: se referă la codurile de eroare raportate de fiecare parte internă a vehiculului.',
      text7: 'Date despre locația vehiculului: se referă la locația geografică specifică a vehiculului.',
      text8: '1.1.	Furnizarea ing Clientul cu servicii legate de vehicul prin APLICIA CFMOTO RIDE ',
      text9:
        '1.1.1.	Consumatorii pot gestiona vehiculele de la distanță prin intermediul aplicației CFMOTO RIDE (inclusiv vizualizarea locației vehiculului, setarea informațiilor și funcțiilor vehiculului, controlul de la distanță a stării vehiculului etc.).',
      text10: '1.1.2.	Furnizarea de planificare a rutei în timpul navigării, inclusiv calcularea distanței dintre vehicule și navigarea pe jos în scopul găsirii unui vehicul .',
      text11: '1.2.	Trimiterea notificărilor necesare către Client în funcție de condițiile vehiculului.',
      text12:
        '1.2.1.	CFMOTO va încheia notificările Clientului privind întreținerea vehiculului (de exemplu, în funcție de distanța totală pe care o parcurge Clientul, momentul la care Clientul cumpără vehiculul, cerințele de timp sau distanță de condus pentru întreținerea vehiculului) .',
      text13:
        '1.2.2.	Pe baza datelor vehiculului , CFMOTO va trimite Clientului notificări privind situația anormală; inclusiv analiza datelor de către OEM (în funcție de model) pentru a oferi asistență clienților și optimizarea ulterioară a vehiculului .',
      text14: '1.3.	Asistență în analiza cauzei accidentului în cazul în care Clientul raportează un accident grav al Autovehiculului.',
      text15:
        '1.3.1.	În cazul unui accident grav al Vehiculului, cum ar fi atunci când Vehiculul se răstoarnă sau se răstoarnă pe o parte în timpul conducerii, CFMOTO va sprijini Clientul la cerere în a clarifica dacă accidentul se datorează unei defecțiuni a Vehiculului sau altor circumstanțe. Solicitarea urmează să fie înaintată către CFMOTO de către Client prin intermediul distribuitorului/partenerului de vânzări local indicat în Contractul de vânzare a vehiculelor.',
      text16: '1.3.2.	În măsura în care datele disponibile permit acest lucru, CFMOTO va evalua datele în raport cu cauza accidentului și va furniza Clientului un raport corespunzător.',
      text17: '1.4.	Asistență pentru Client pentru recuperarea Vehiculului după pierderea Vehiculului .',
      text18:
        '1.4.1.	Dacă Vehiculul este pierdut, CFMOTO va furniza Clientului datele de locație ale Vehiculului și alte date utile de stare a Vehiculului (cum ar fi locația ultimei activări, starea curentă a vehiculului etc.) la cerere și dacă sunt disponibile.',
      text19: '1.4.2.	Solicitarea urmează să fie înaintată către CFMOTO de către Client prin intermediul distribuitorului/partenerului de vânzări local indicat în Contractul de vânzare a vehiculelor.',
      text20: '1.5.	Raportarea problemelor post-vânzare .',
      text21: '1.5.1.	CFMOTO colectează de la distanță notificări cu coduri de eroare trimise de Vehicul în cazul unei defecțiuni a componentelor sale și furnizează informațiile respective la cererea Clientului direct Clientului.',
      text22: '1.5.2.	Solicitarea urmează să fie înaintată către CFMOTO de către Client prin intermediul distribuitorului/partenerului de vânzări local indicat în Contractul de vânzare a vehiculelor.',
      text23: '2.	Restricții și excluderi ale serviciului',
      text24:
        '2.1.	Se subliniază în mod expres că modificările structurale sau alte modificări tehnice ale Vehiculului pot limita furnizarea serviciilor sau chiar o pot face imposibilă, deoarece serviciile depind de furnizarea corectă a datelor vehiculului.',
      text25: '2.2.	În cazul în care astfel de servicii nu pot fi furnizate din cauza performanței oricăror rețele de date sau de telecomunicații terță parte , orice răspundere a CFMOTO este exclusă.',
      text26: '3.	Confidențialitate',
      text27:
        'CFMOTO va respecta reglementările aplicabile privind protecția datelor atunci când prelucrează datele cu caracter personal în legătură cu vehiculul CFMOTO . Termenii politicii de confidențialitate a CFMOTO sunt stabiliți în această aplicație CFMOTO RIDE . Ca un supliment la politica de confidențialitate , această notificare respectă politica de confidențialitate . Și Clientul se poate referi la politica de confidențialitate pentru unele conținuturi legate de prelucrarea datelor care nu sunt acoperite de această notificare.',
      text28: '4.	Serviciu clienți',
      text29:
        '4.1.	Clientul se poate simți liber să trimită întrebări, comentarii sau preocupări legate de confidențialitate la CFMOTORIDEAPP@cfmotousa.com sau să scrie la: CFMOTO Powersports, Inc., 3555 Holly Lane North, Suite 30, Plymouth, M N 55447. Clientul poate, de asemenea, suna Relații cu clienții CFMOTO la (888) 823-6686. ',
      text30: '5.	Revizii _',
      text31: '5.1.	CFMOTO își rezervă dreptul de a modifica această notificare în orice moment, dar vom publica revizuiri pe CFMOTO RIDE Aplicați și/sau furnizați o notificare înainte de a face acest lucru, după caz.',
    },

    atmosphere: {
      desTitle: '功能说明',
      setINfo: 'Noile setări vor intra în vigoare în 1-3 minute de la pornirea vehiculului, vă rugăm să vă asigurați că vehiculul este într-o poziție bună a semnalului',
      setSuccess: 'Setați cu succes',
      sure: 'Sigur',
      confirm: 'Confirmă',
      cancel: 'Anulează',
      cContent: 'Setările nu au fost încă salvate, doriți să le salvați?',
      save: 'Salvează setările',
      introduce1: 'Aproape de instrucțiuni de deblocare automată',
      introduce2: 'instrucțiuni de oprire automată',
      introduce3: 'Instrucțiuni de trezire automată',
      introduce4: 'Luminile stinse cu întârziere',
      content1: {
        msg1: 'După ce funcția este activată, telefonul mobil pornește Bluetooth și aplicația continuă să ruleze. Când vă apropiați de vehicul de departe până aproape, vehiculul poate fi deblocat și pornit automat.',
        msg2: 'Dacă în mod normal nu este deblocat și pornit, apăsați butonul de alimentare al vehiculului pentru a debloca și porni',
        msg3: 'Deblocarea automată de proximitate va fi declanșată o singură dată înainte de deconectarea Bluetooth',
      },
      content2: {
        msg1: 'După ce funcția este activată, vehiculul se va opri automat după 5 secunde după oprirea celor trei condiții ale vehiculului, viteza vehiculului este 0 și templul este abandonat',
        msg2: 'Pornirea vehiculului în timpul perioadei de oprire automată, viteza vehiculului nu este 0 sau templul este pus deoparte va anula oprirea automată',
      },
      content3: {
        msg1: 'După ce funcția este pornită, când vehiculul este oprit, telefonul mobil pornește Bluetooth și aplicația continuă să funcționeze sau poartă cheia fizică. Când vă apropiați de vehicul de departe până aproape, luminile vehiculului vor clipi pentru a întâmpina oaspeții',
        msg2: 'Pentru a preveni declanșatoarele frecvente să provoace pierderi de putere ale vehiculului, după ce funcția de întâmpinare este declanșată de două ori în decurs de 30 de secunde, aceasta nu se va relua decât după 30 de minute',
      },
      content4: {
        msg1: 'După ce funcția este activată, luminile pentru faza lungă și scurtă vor fi aprinse automat timp de 10 secunde după ce vehiculul este oprit',
      },
    },
    feedback: {
      label: {
        type: 'Tip de feedback (o singură alegere)',
        content: 'Descrierea problemei',
        fileList: 'Vă rugăm să încărcați o fotografie',
        fileList2: '(Maxim 4 fotografii / 1 video)',
        feedbackCreate: 'Faceți clic pentru feedback',
        feedbackSupplement: 'Feedback suplimentar',
        backHome: 'Înapoi la pagina principală',
        vehicle: 'vehicul asociat',
        selectVehicle: 'selectați vehiculul',
      },
      placeholder: {
        'content.bug': 'Vă rugăm să descrieți în detaliu momentul apariției, versiunea APP, modelul de telefon mobil, calea de operare și descrierea problemei pentru a ajuta la localizarea și rezolvarea rapidă a problemei!',
        'content.suggest': 'Bine ați venit pentru a face sugestii valoroase, vom lua în considerare serios ideile dvs.',
        'content.vehicle': 'Vă rugăm să descrieți când s-a întâmplat, cum s-a întâmplat și care este problema',
        'content.other': 'Vă rugăm să descrieți când s-a întâmplat, cum s-a întâmplat și care este problema',
        'content.supplement': 'Vă rugăm să adăugați o descriere a problemei',
        vehicle: 'Vă rugăm să selectați un vehicul',
      },
      rules: {
        'type.required': 'Vă rugăm să selectați un tip de feedback',
        'content.required': 'Vă rugăm să introduceți o descriere a problemei dvs.',
        'fileList.uploading': 'Încărcare, vă rugăm să așteptați',
        'fileList.maxSize': 'Fișierul încărcat este prea mare',
        'fileList.overType': 'Format neacceptat',
        'fileList.maxCount': 'Numărul de încărcări depășește limita',
        'fileList.acceptImageVideo': 'Video nu poate fi selectat atunci când se selectează imagini',
        'vehicle.required': 'Vă rugăm să selectați un vehicul',
      },
      message: {
        empty: 'Nu există înregistrări de feedback în acest moment.',
        finish: 'Răspunde',
        loading: 'Se încarcă',
        uploadFailed: 'Încărcare eșuată',
        tip: 'Pentru a proteja securitatea contului dvs., vă rugăm să nu trimiteți aici informații personale sensibile, cum ar fi parolele conturilor etc. ',
        feedbackSuccess: 'Înapoi la pagina principală',
        'submit.error': 'Feedback eșuat',
        'submit.success': 'Înapoi la pagina principală',
      },
    },
    guide: {
      label: { giveFeedback: 'Nerezolvat, vreau să dau feedback' },
    },
    help: {
      label: {
        history: 'Căutați înregistrări',
        cancel: 'Anula',
        yes: 'Da',
        no: 'Nu',
        unresolved: 'Încă nu se poate rezolva? Clic',
        submitFeedback: 'Trimite parerea ta',
      },
      placeholder: {
        search: 'Căutare',
        'content.required': 'Vă rugăm să introduceți cuvântul cheie',
      },
      message: {
        empty: 'Nu există conținut similar',
        empty2: 'Sugerați schimbarea cuvintelor cheie sau',
        finish: 'Răspunde',
        historyDelete: 'Ștergeți toate înregistrările de căutare?',
        isHelpful: 'Ajută?',
      },
    },
    unbinding: {
      label: {
        vin: 'Serie de șasiu',
        realName: 'Numele dvs. comple',
        email: 'Adresa de e-mail',
        phone: 'Număr de telefon',
        areaCode: 'Codul tarii',
        identity: 'Identificare',
        drivingLicense: 'Certificatul de înmatriculare a vehiculului.',
        backHome: 'Înapoi la pagina principală',
        areaCodeTitle: 'Codul țării',
        latterTitle: 'Înștiințare',
        agree: 'Aprobare',
        disagree: 'Nu sunt de acord',
        agreeCheckLabel: 'Am citit și sunt de acord',
        agreeCheckTitle: 'Instrucțiuni pentru aplicarea pentru deblocarea vehiculului',
      },
      placeholder: {
        vin: 'Vă rugăm să introduceți VIN-ul',
        realName: 'Vă rugăm să introduceți numele dvs. real',
        email: 'Te rugam sa introduci adresa ta de email',
        phone: 'Vă rugăm să introduceți numărul dvs. de telefon',
        identity: 'Pagina principală a cărții de identitate, permisului de conducere sau pașaportului care conține informații personale de identificare.',
        drivingLicense: 'Pagina principală a certificatului de înmatriculare a vehiculului cu numele proprietarului și VIN-ul.',
      },
      rules: {
        'agree.required': 'Vă rugăm să citiți și să fiți de acord',
        'vin.required': 'Vă rugăm să introduceți VIN-ul',
        'vin.pattern': 'VIN greșit, vă rugăm să verificați.',
        'realName.required': 'Vă rugăm să introduceți numele dvs. real',
        'email.required': 'Te rugam sa introduci adresa ta de email',
        'email.pattern': 'Formatul adresei de e-mail este greșit, vă rugăm verificați.',
        'phone.required': 'Vă rugăm să introduceți numărul dvs. de telefon',
        'phone.pattern': 'Eroare de format a numărului de telefon, vă rugăm să verificați',
        'fileList.maxCount': 'Numărul de încărcări depășește limita',
        'fileList.uploading': 'Încărcare, vă rugăm să așteptați',
      },
      message: {
        imgUploadFailed: 'Încărcarea imaginii nu a reușit',
        securityMessage: 'Informațiile de mai sus sunt utilizate doar în scopul verificării identității, CFMOTO protejează informațiile dumneavoastră.',
        resultMessage: 'Vom verifica materialele aplicației cât mai curând posibil, vă rugăm să acordați atenție barei de notificare sau centrului de mesaje APP la timp.',
        loading: 'Se încarcă',
      },
    },
  },
};
